/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import BeneficiaryAccountEditStepPAN from "../../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditStepPAN/index.jsx";
import {
  beneficiaryAccountDetailsById,
  resetUpdateBeneficiaryAccount,
  updateBeneficiaryAccount,
} from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  panLookUp,
  resetGSTVerification,
  resetPanLookup,
  resetPANVerification,
  verifyGST,
  verifyPAN,
} from "../../../../../redux/features/sharedResources/sharedResources";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText.js";
import Validation from "../../../../../utils/validation";
import GSTVerification from "../../../../Settings/GSTDetails/index.jsx";
import "./index.css";

const BeneficiaryAccountEditPAN = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const retryCountRef = useRef(0);
  const verifyDebounceRef = useRef(null);
  const associatedAccountRef = useRef(null);
  const [, setShowAccInfo] = useState(false);
  const [GSTLinked, setGSTLinked] = useState(true);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [updateActive, setUpdateActive] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [isLeavePopupOpen, setIsLeavePopupOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [isUpdateEnabled, setIsUpdateEnabled] = useState(false);
  const [confirmEnable, setConfirmEnable] = useState(false);
  const [accountActiveInactiveState, setAccountActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Beneficiary account",
  );
  const [updatedGst, setUpdatedGst] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    newGstValue: "",
  });
  const [isGstnPresent, setIsGstnPresent] = useState(false);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  const {
    panVerificationLoading,
    panVerificationData,
    gstVerificationData,
    gstVerificationLoading,
    panLookupLoading,
    panLookupData,
    panLookupError,
  } = useSelector((state) => state.sharedResources);

  const { beneficiaryAccountDetailsData, beneficiaryAccountDetailsLoading } =
    useSelector((state) => state.beneficiaryAccount);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: panLookupError
        ? isNextButtonEnabled
        : isUpdateEnabled && !updateActive,
      previousIsDisabled: updateActive || panLookupLoading,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "PAN details",
    },
  ];

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value.replace(/(\w)(\w*)/g, (first, char, rest) => {
        return char.toUpperCase() + rest.toLowerCase();
      });
    }

    if (type === "gstin") {
      return value.toUpperCase();
    }

    return value.trim();
  };

  const allowedValue = (name, value) =>
    name !== "gstin" || Validation.allowedGstin(value);

  const validateAndRecordError = (name, value) => {
    if (name !== "gstin") return;

    setCustomErrors((prev) =>
      Validation.validateGstin(name, value, { ...prev }),
    );
  };

  const handleBack = () => {
    if (hasUnsavedChanges) {
      setIsLeavePopupOpen(true);
      return;
    }
    navigate(-1);
  };

  const handleLeavePage = () => {
    navigate(-1);
  };
  const handlePANChange = (e) => {
    let inputPan = e.target.value.toUpperCase();
    inputPan = inputPan.replace(/[^A-Z0-9]/g, "");

    if (inputPan.length > GlobalConfiguration.panLength) return;
    if (inputPan === payload.panNumber) return;
    const updatedPayload = {
      ...payload,
      panNumber: inputPan,
      gstin: "",
    };

    setPayload(updatedPayload);

    const original = beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

    setHasUnsavedChanges(
      original?.pan_no !== updatedPayload.panNumber ||
        (original?.gstin_detail || "") !== (updatedPayload.gstin || ""),
    );

    if (
      !panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetPanLookup());
    } else if (inputPan.length === GlobalConfiguration.panLength) {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }

      if (panRegex.test(inputPan)) {
        setVerifiedPan(null);
        dispatch(resetPanLookup());
        verifyDebounceRef.current = setTimeout(() => {
          verifyDebounceRef.current = null;
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;

          if (panRegex.test(inputPan)) {
            dispatch(
              verifyPAN({
                pan_number: inputPan,
                navigate,
                showToast: false,
              }),
            );
          }
        }, IntervalConfiguration.intervalMedium);
      }
    } else {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }

      retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      setVerifiedPan(null);
      setShowAccInfo(false);
      sessionStorage.removeItem("PAN GST Edit NewValue");
    }

    dispatch(resetGSTVerification());
    setIsLinkedAccount(false);
    setAlreadyLinked(false);
  };

  const handleUpdateAccount = async () => {
    if (updateActive) return;

    setUpdateActive(true);
    try {
      const response = await dispatch(
        updateBeneficiaryAccount({
          id,
          pan: payload?.panNumber,
          name: payload?.legalName,
          gstin: payload?.gstin,
          navigate,
        }),
      ).unwrap();

      if (response?.status) {
        const prev = beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];
        const updatedFields = [];

        if (prev?.pan_no !== payload.panNumber) {
          updatedFields.push("pan_no");
        }

        if ((prev?.gstin_detail || "") !== (payload.gstin || "")) {
          updatedFields.push("gstin_detail");
        }
        const fieldsToPass =
          updatedFields.length > 0 ? updatedFields : ["pan_no", "gstin_detail"];
        localStorage.setItem("haveAssociated", JSON.stringify(panLookupError));
        dispatch(resetUpdateBeneficiaryAccount());

        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/pan_edit_success/${id}`,
          {
            state: {
              updatedFields: fieldsToPass,
              isGstnPresent: isGstnPresent,
            },
          },
        );
      }
    } catch (err) {
      console.log("Update failed", err);
    } finally {
      setUpdateActive(false);
    }
  };

  const handleGSTChange = (e) => {
    const { name, value } = e.target;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, "");
    const newValue = modifyValue(name, sanitizedValue);

    if (!allowedValue(name, value)) return;

    validateAndRecordError(name, newValue);

    const updatedPayload = {
      ...payload,
      [name]: newValue,
    };

    setPayload(updatedPayload);

    const original = beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

    setHasUnsavedChanges(
      original?.pan_no !== updatedPayload.panNumber ||
        (original?.gstin_detail || "") !== (updatedPayload.gstin || ""),
    );

    if (value.trim() === "" && value.length === 1) return;
    if (name !== "gstin") return;

    const length = newValue.length;

    if (length === GlobalConfiguration.gstLength) {
      dispatch(resetGSTVerification());
      dispatch(verifyGST({ search_string: newValue }));
    }
  };

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(beneficiaryAccountDetailsById({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    sessionStorage.setItem("Pan Gst Verification", JSON.stringify(updatedGst));
  }, [updatedGst]);

  useEffect(() => {
    if (
      verifiedPan &&
      payload.panNumber?.length === GlobalConfiguration.panLength
    ) {
      dispatch(panLookUp({ pan_number: payload.panNumber }));
    }
  }, [verifiedPan, payload.panNumber]);

  useEffect(() => {
    if (payload.gstin?.length > 0 && gstVerificationData?.status === true) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
    }

    if (payload.gstin?.length > 0 && gstVerificationData?.message) {
      let errors = { ...customErrors };
      errors["gstin"] = gstVerificationData.message;
      setCustomErrors(errors);
    }
  }, [gstVerificationData]);

  useEffect(() => {
    if (gstVerificationLoading) return;

    const gstLength = payload.gstin?.length || 0;

    if (gstLength === GlobalConfiguration.gstLength) {
      const gstEmbeddedPan = payload.gstin.substring(
        2,
        payload.gstin.length - 3,
      );
      const isApiVerified = gstVerificationData?.status === true;
      const isPanLinked = gstEmbeddedPan === payload.panNumber;

      if (isApiVerified && isPanLinked) {
        setGstVerified(true);
        setGSTStatus(true);
        setGSTLinked(true);
      } else {
        setGstVerified(false);
        setGSTStatus(false);
        setGSTLinked(isPanLinked);
      }
    } else if (gstLength === GlobalConfiguration.lengthCheckZero) {
      setGstVerified(null);
      setGSTStatus(null);
      setGSTLinked(false);
    } else {
      setGstVerified(false);
      setGSTStatus(false);
      setGSTLinked(false);
    }
  }, [
    payload.gstin,
    payload.panNumber,
    gstVerificationData,
    gstVerificationLoading,
  ]);

  const showGSTLinkedAlert =
    !!beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.gstin_detail;

  const isGstEmpty = !payload.gstin || payload.gstin.length === 0;
  const isGstComplete = payload.gstin?.length === GlobalConfiguration.gstLength;
  const isGstVerifiedAndLinked =
    isGstComplete && GSTStatus === true && gstVerified === true;
  const isGSTPanMatched =
    isGstComplete &&
    payload?.gstin?.substring(2, payload.gstin.length - 3) ===
      payload.panNumber;

  const showGSTNotLinked =
    isGstComplete && gstVerificationData?.status === true && !isGSTPanMatched;

  const hadOriginalGstForConfirm =
    !!beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.gstin_detail;

  const gstOkForConfirm = isGstEmpty
    ? !hadOriginalGstForConfirm
    : isGstComplete && isGstVerifiedAndLinked && isGSTPanMatched;

  const canConfirm =
    !!payload.panNumber &&
    verifiedPan === true &&
    !(isLinkedAccount || alreadyLinked) &&
    gstOkForConfirm;

  useEffect(() => {
    setIsUpdateEnabled(false);
  }, [payload.panNumber, payload.gstin]);

  useEffect(() => {
    const original = beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

    const hasPan = !!payload.panNumber;
    const hadOriginalGst = !!original?.gstin_detail;

    const panChanged = original?.pan_no !== payload.panNumber;
    const gstChanged = (original?.gstin_detail || "") !== (payload.gstin || "");

    let shouldEnable = true;

    // Disable while API is in progress
    if (panLookupLoading || updateActive) {
      shouldEnable = false;
    }

    // PAN is mandatory
    else if (!hasPan) {
      shouldEnable = false;
    }

    // PAN must be verified
    else if (verifiedPan !== true) {
      shouldEnable = false;
    }

    // Duplicate PAN + Bank combination exists
    else if (isLinkedAccount || alreadyLinked) {
      shouldEnable = false;
    }

    // User hasn't changed anything
    else if (!panChanged && !gstChanged) {
      shouldEnable = false;
    }

    // Scenario 1: account originally had BOTH PAN + GST. After removing
    // the previous GST, a new GST value is required before the Update
    // button can be enabled again — PAN alone isn't enough here.
    else if (hadOriginalGst && isGstEmpty) {
      shouldEnable = false;
    }

    // Scenario 2: account originally had NO GST, and GST is still
    // empty — PAN alone (verified + changed) is enough to enable.
    else if (!hadOriginalGst && isGstEmpty) {
      shouldEnable = true;
    }

    // Scenario 3: a GST value IS present (whether the account originally
    // had one or not). It must be complete, verified+linked, and match
    // the PAN before the button is allowed to enable.
    else if (!isGstEmpty) {
      if (!isGstComplete || !isGstVerifiedAndLinked || !isGSTPanMatched) {
        shouldEnable = false;
      }
    }

    setIsNextButtonEnabled(shouldEnable);
  }, [
    beneficiaryAccountDetailsData,
    panLookupLoading,
    updateActive,
    verifiedPan,
    isLinkedAccount,
    alreadyLinked,
    payload.panNumber,
    payload.gstin,
    GSTStatus,
    gstVerified,
  ]);

  useEffect(() => {
    const original = beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

    const panChanged = original?.pan_no !== payload.panNumber;

    const gstChanged = (original?.gstin_detail || "") !== (payload.gstin || "");

    if (original?.gstin_detail) {
      setIsGstnPresent(true);
    }

    if (panChanged || gstChanged) {
      setConfirmEnable(true);
    } else {
      setConfirmEnable(false);
    }
  }, [beneficiaryAccountDetailsData, payload.panNumber, payload.gstin]);

  useEffect(() => {
    if (
      !panLookupLoading &&
      !panVerificationLoading &&
      panLookupError === true &&
      verifiedPan &&
      payload.panNumber?.length === GlobalConfiguration.panLength
    ) {
      setShowDetail(true);
    } else {
      setShowDetail(false);
    }
  }, [
    panLookupLoading,
    panVerificationLoading,
    panLookupError,
    verifiedPan,
    payload.panNumber,
  ]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsLoading ||
      !beneficiaryAccountDetailsData?.status
    ) {
      return;
    }

    const account = beneficiaryAccountDetailsData.beneficiary_accounts?.[0];

    setUpdatedGst({
      id: account?.id,
      panNo: account?.pan_no,
      gstNo: account?.gstin_detail,
    });

    setPayload((prev) => ({
      ...prev,
      panNumber: account.pan_no,
      gstin: account.gstin_detail,
      legalName: account.pan_legal_name,
    }));

    setVerifiedPan(true);
    dispatch(resetPANVerification());
    if (account?.gstin_detail?.length === GlobalConfiguration.gstLength) {
      setGstVerified(null);
      setGSTStatus(null);
      dispatch(resetGSTVerification());
      dispatch(verifyGST({ search_string: account.gstin_detail }));
    }
  }, [beneficiaryAccountDetailsLoading, beneficiaryAccountDetailsData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  useEffect(() => {
    if (gstVerificationData?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: gstVerificationData?.gstin_details?.business_name,
      });
    }
  }, [gstVerificationData]);

  const closeGSTPopupModal = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (panVerificationData?.status !== undefined) {
      setVerifiedPan(panVerificationData?.status);
    }
  }, [panVerificationData]);

  const currentBankAccNo =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.bank_acc_no;
  const isPanChanged =
    payload.panNumber !==
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.pan_no;

  useEffect(() => {
    const pan = payload.panNumber;
    const originalPan =
      beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.pan_no;
    const isFullPan = pan?.length === GlobalConfiguration.panLength;

    if (!isFullPan || verifiedPan !== true || panLookupLoading) {
      if (!isFullPan) {
        setAlreadyLinked(false);
        setIsLinkedAccount(false);
      }
      return;
    }

    const accounts = panLookupData?.beneficiary_accounts ?? [];
    if (!accounts.length) return;

    const isPanChanged = pan !== originalPan;
    const linkedToThis =
      isPanChanged &&
      currentBankAccNo &&
      accounts.some((v) => v?.bank_acc_no === currentBankAccNo && v?.id === id);
    const linkedToOther =
      isPanChanged &&
      accounts.some((v) => v?.bank_acc_no === currentBankAccNo && v?.id !== id);

    setAlreadyLinked(!!linkedToThis);
    setIsLinkedAccount(!!linkedToOther);
  }, [payload.panNumber, panLookupData, panLookupLoading, verifiedPan, id]);

  return (
    <>
      {showPopup && (
        <div className="fixed top-top_base left-left_base w-screen h-screen flex items-center justify-center z-z-index-modal Qmd:bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="GST Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate("/settings/GST_verification", {
                state: gstVerificationData?.gstin_details?.gstin_no,
              })
            }
            closeiconhandleFunction={() => setShowPopup(false)}
          >
            <GSTVerification
              gst_number={gstVerificationData?.gstin_details?.gstin_no}
              closeGSTDetailsModal={closeGSTPopupModal}
              popup={true}
              setShowPopup={setShowPopup}
              showPopup={showPopup}
            />
          </LargePopupRedirect>
        </div>
      )}
      {isLeavePopupOpen && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            subtext={
              payload.panNumber?.length !== GlobalConfiguration.panLength
                ? globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW
                : globalText?.EXIT_CURRENT_FLOW_NOTE
            }
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            btnOneText={globalText?.STAY}
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setIsLeavePopupOpen(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleLeavePage}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="flex flex-col items-center max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md">
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <TopNavComponent
              topNavHeader="Beneficiary Account"
              topNavSubText="PAN details"
              isFormattingNotRequired
            />
          </div>
          <div className="h-[var(--stepper-height)] block Qmd:hidden"></div>
        </div>
        <div
          className="w-width-full overflow-auto Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base h-full flex justify-center"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="w-width-full">
            <div
              className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md"
              style={{ scrollbarWidth: "none" }}
            >
              <BeneficiaryAccountEditStepPAN
                verifiedPan={verifiedPan}
                handlePANChange={handlePANChange}
                panDetails={
                  isPanChanged
                    ? panVerificationData?.pan_details
                    : { full_name: payload.legalName }
                }
                panLookupData={panLookupData}
                panVerificationLoading={panVerificationLoading}
                isLinkedAccount={isLinkedAccount}
                payload={payload}
                accountActiveInactiveState={accountActiveInactiveState}
                setAccountActiveInactiveState={setAccountActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                gstVerificationData={gstVerificationData}
                gstVerificationLoading={gstVerificationLoading}
                setShowPopup={setShowPopup}
                GSTStatus={GSTStatus}
                gstVerified={gstVerified}
                GSTLinked={GSTLinked}
                handleGSTChange={handleGSTChange}
                showGSTLinkedAlert={showGSTLinkedAlert}
                isUpdateEnabled={isUpdateEnabled}
                setIsUpdateEnabled={setIsUpdateEnabled}
                confirmEnable={confirmEnable}
                canConfirm={canConfirm}
                showGSTNotLinked={showGSTNotLinked}
                isGstnPresent={isGstnPresent}
                showDetail={showDetail}
              />
            </div>
          </div>
        </div>
        <div className="h-stepper-moble-height flex-shrink-0 Qsmd:h-pagination-height block Qsmd:hidden"></div>
      </div>
    </>
  );
};

export default BeneficiaryAccountEditPAN;
